<template>
  <div class="dropdown">
    <label class="dropdown-label">
      {{ label }}
      <span v-if="required" class="u-color-danger"> *</span>
    </label>

    <div class="dropdown-select">
      <select v-model="localValue" :disabled="disabled" @blur="$emit('blur')">
        <option :value="null" disabled selected>選択してください</option>
        <template v-for="option in options">
          <option :value="option.value">{{ option.name }}</option>
        </template>
      </select>
      <PublishBadge v-if="isPublish" class="publish-badge"></PublishBadge>
    </div>

    <div class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import PublishBadge from "@/components/PublishBadge";

export default {
  name: "Dropdown",
  components: { PublishBadge },
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    isPublish: {
      type: Boolean,
      required: false
    },
    errorMessage: {
      type: String,
      required: false
    },
    value: {
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dropdown {
  position: relative;

  &-label {
    color: #CAC9C9;
  }

  &-select {
    select {
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
      border: none;
      letter-spacing: 0.03rem;
      outline: none;
      height: 42px;
      width: 100%;
      -webkit-appearance: none;
      border-radius: 1px;
      appearance: none;
    }
  }
}

.error {
  box-shadow: 0 2px 0 #f94848 !important;
  background: rgba(241, 72, 72, .1);
}

.error-message {
  padding-top: 7px;
  padding-bottom: 7px;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: .03em;
  color: #f14848;
  height: 40px;
}

.publish-badge {
  font-size: 10px;
  position: absolute;
  right: 5px;
  top: 30%;
  background-color: white;
}
</style>
